import React from 'react'
import { Button, Result } from 'antd'

// Cada imagen contiene solo los assets de su propio build, así que un import()
// de una ruta lazy puede fallar mientras el rollout está a medias. Sin este
// boundary React desmonta el árbol entero y el usuario se queda con la pantalla
// en blanco, sin forma de salir de ahí.

const RELOAD_FLAG = 'chunkErrorReloadedAt'
const RELOAD_COOLDOWN_MS = 10000

const isChunkLoadError = error => {
  if (!error) return false
  if (error.name === 'ChunkLoadError') return true
  const message = String(error.message || '')
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Importing a module script failed')
  )
}

// sessionStorage puede no estar disponible (modo restringido del navegador), y
// quedarnos sin recargar es preferible a romper el propio manejo del error.
const readLastReload = () => {
  try {
    return Number(window.sessionStorage.getItem(RELOAD_FLAG)) || 0
  } catch {
    return 0
  }
}

const writeLastReload = value => {
  try {
    window.sessionStorage.setItem(RELOAD_FLAG, String(value))
  } catch {
    // sin persistencia perdemos la protección anti-bucle, no la recarga
  }
}

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return

    // Recargamos una sola vez: si el chunk sigue fallando tras el refresco
    // dejamos la pantalla de reintento manual en lugar de entrar en bucle.
    const now = Date.now()
    if (now - readLastReload() < RELOAD_COOLDOWN_MS) return

    writeLastReload(now)
    window.location.reload()
  }

  render() {
    const { error } = this.state
    const { children } = this.props

    if (!error) return children

    // El resto de errores se propagan como hasta ahora: este boundary solo se
    // ocupa de los fallos de carga de chunks.
    if (!isChunkLoadError(error)) throw error

    return (
      <Result
        status="warning"
        title="No se ha podido cargar esta página"
        subTitle="Puede que se haya publicado una versión nueva del panel. Recarga para continuar."
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            Recargar
          </Button>
        }
      />
    )
  }
}

export default ChunkErrorBoundary
